var app = angular.module('leonardo');

var AuthService = function($http, $q, $rootScope, $state, $window, jwtHelper, $timeout, BroadcastChannelService,
                           ConfigThemeService, CacheService, ThoughtSpotService) {
  var service = {
    user: null,
    cancelerUser: $q.defer(),
    cancelerToken: $q.defer(),
    cancelerTokenRefresh: $q.defer()
  };

  service.getToken = function(email, password, legal_terms) {
    var url = ConfigThemeService.generateURL('/api/v2/api-token-auth/');
    var data = {
      email: email,
      password: password
    };
    if (legal_terms) {
      data.accepted_legal_terms = legal_terms;
    }
    var defer = $q.defer();
    service.cancelerToken.resolve();
    service.cancelerToken = $q.defer();
    $http.post(url, data, { skipAuthorization: true, timeout: service.cancelerToken.promise }).then(function(resp) {
      resp = resp.data;
      if (resp.token) {
        localStorage.setItem('jwt_token', resp.token);
        localStorage.setItem('orig_iat', new Date().getTime() / 1000)
      }
      defer.resolve(resp);
    }).catch(function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.validateUser = function (email, legal_terms) {
    var url = ConfigThemeService.generateURL('/api/v2/api-token-auth/');
    var data = {
      email: email,
      origin: window.location.origin,
    };
    if (legal_terms) {
      data.accepted_legal_terms = legal_terms;
    }
    var uri = new URI(url);
    return $http.get(uri.query(data).toString(), { skipAuthorization: true });
  }

  service.hasToken = function() {
    return !isNull(localStorage.getItem("jwt_token"));
  };

  service.hasOldToken = function() {
    return !isNull(localStorage.getItem("jwt_token_old"));
  };

  service.getOldToken = function() {
    return localStorage.getItem("jwt_token_old");
  };

  service.getOldUserId = function() {
    return localStorage.getItem("jwt_user_id_old");
  };

  service.getDecodedToken = function() {
    let token = localStorage.getItem('jwt_token');
    if (isNull(token) || (token === 'null')) return null;
    return jwtHelper.decodeToken(token);
  };

  service.tokenRefresh = function (token) {
    var now = new Date().getTime() / 1000;
    localStorage.setItem('jwt_token', token);
    localStorage.setItem('orig_iat', now);
  };

  service.refreshToken = function() {
    var url = ConfigThemeService.generateURL('/api/api-token-refresh/');
    var data = {
      token: localStorage.getItem('jwt_token'),
      work_as_user: service.hasOldToken()
    };
    service.cancelerTokenRefresh.resolve();
    service.cancelerTokenRefresh = $q.defer();
    var defer = $q.defer();
    $http.post(url, data, { timeout: service.cancelerTokenRefresh.promise }).then(function(resp) {
      resp = resp.data;
      if (resp.token) {
        service.tokenRefresh(resp.token);
      }
      $timeout(() => {
        defer.resolve();
      }, 10);
    }).catch(function (error){
      defer.reject(error);
    });
    return defer.promise;
  };

  service.tokenExpired = function() {
    var token = service.getDecodedToken();
    var now = new Date().getTime() / 1000;
    return isNull(token) || (now > token['exp']);
  };

  service.token50TimeLife = function() {
    var token = service.getDecodedToken();
    var now = new Date().getTime() / 1000;
    if(!localStorage.getItem('orig_iat')) {               // For SSO users localstorage is not set
      localStorage.setItem('orig_iat', token['orig_iat']);
    }
    var orig_iat =  localStorage.getItem('orig_iat');
    var tokenLife = (token['exp'] - orig_iat);  // Token Expiration Time - Token originally Issued at Time
    var passedLife =  now - orig_iat; // passed life time of the token
    var halfLifeTime = !isNull(token) ? tokenLife/2 : null;
    return isNull(token) || ( passedLife > halfLifeTime);
  };

  service.getUser = function(isExclude) {
    var promise = $q.defer();
    var token = service.getDecodedToken();
    if (!token) {
      service.logout();
      promise.reject({});
      if (!$rootScope.isInIframe) {
        $timeout(() => { $window.location.reload() }, 0);
      }
    }
    else {
      service.cancelerUser.resolve();
      service.cancelerUser = $q.defer();
      var url = ConfigThemeService.generateURL('/api/2.0/users/' + token.user_id + '/');
      let params = {};
      if (isExclude) {
        params = {
          exclude: 'account_users'
        };
      }
      CacheService.getOrFetch('user', function (){
        return $http.get(url, {params: params, timeout: service.cancelerUser.promise})
          .then(function(response) {
            return response.data;
          });
      }).then(function(userData) {
        service.user = userData;
        promise.resolve(service.user);
      }).catch(function(){
        service.logout();
        promise.reject({});
        if (!$rootScope.isInIframe) {
          $timeout(() => { $window.location.reload() }, 0);
        }
      });
    }
    return promise.promise;
  };

  service.register = function(data, account) {
    var url = account ? ConfigThemeService.generateURL('/api/2.0/accounts/') : ConfigThemeService.generateURL('/api/2.0/account-requests/');
    var data_user = data;
    var promise = $q.defer();
    data['noerror'] = true;
    $http.post(url, data).then(function() {
      promise.resolve(data_user);
    }).catch(function(err){
      promise.reject(err);
    });
    return promise.promise;
  };

  service.getUserById = function(pk) {
    var url = ConfigThemeService.generateURL('/api/2.0/user/' + pk + '/');
    return $http.get(url);
  };

  // Drop credentials the server has already rejected, without waiting for the
  // user to dismiss a dialog. showLogout() only calls logout() once the dialog
  // resolves, and until then the stale token keeps driving authenticated
  // requests on every state change.
  //
  // Deliberately does not broadcast 'user:logout': that tears down authData,
  // filters and third-party widgets, which would break the page still rendered
  // behind the dialog. logout() performs that teardown when the user acts.
  service.invalidateSession = function() {
    if (!service.hasToken()) {
      return;
    }
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('orig_iat');
  };

  service.logout = function(invalid) {
    const skipCall = service.tokenExpired() || invalid;
    var remember = localStorage.getItem('remember_email');
    var urlRedirect = localStorage.getItem('url_redirect');
    var url = ConfigThemeService.generateURL('/api/logout/');
    var deferLogout = $q.defer();
    if (!skipCall) {
     $http.post(url, {session_id: localStorage.getItem('session_id') || undefined}).then(function(data) {
       deferLogout.resolve(data);
     })
     .catch(function(){
       deferLogout.resolve();
     });
    }
    else {
     deferLogout.resolve();
    }
    $q.when(deferLogout.promise).then(function (data) {
      let result = data?.data || data;
      // Ensure ThoughtSpot session is also terminated
      try { ThoughtSpotService.logout && ThoughtSpotService.logout(); } catch (e) { /* noop */ }
      const fromLegacy = localStorage.getItem('from_legacy') === 'true';
      localStorage.clear();
      if (fromLegacy) {
        localStorage.setItem('from_legacy', 'true');
      }
      CacheService.clearAll();
      if (remember) {
        localStorage.setItem('remember_email', remember);
      }
      // Preserve redirect URL for iframe re-authentication after session expiration
      if (urlRedirect) {
        localStorage.setItem('url_redirect', urlRedirect);
      }
      ConfigThemeService.restoreTheme();
      $rootScope.$broadcast('user:logout');

      $timeout(() => {
        BroadcastChannelService.postMessage({
          type: 'logout',
          message: 'User logged out'
        });
      }, 10);
      if (result?.action === 'redirect'){
        window.location.replace(result?.url);
      }
      else{
        $state.go('home', {token: ''});
      }
    });
    return deferLogout.promise;
  };

  return service;
};

app.factory('AuthService', ['$http', '$q', '$rootScope', '$state', '$window', 'jwtHelper', '$timeout', 'BroadcastChannelService', 'ConfigThemeService', 'CacheService', 'ThoughtSpotService', AuthService]);
